var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitchPeque(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48ZM12.3312 11.2L10.4529 16.2088V36.2416H17.3366V40H21.0948L24.8493 36.2416H30.4825L37.9951 28.7317V11.2H12.3312Z",
    fill: "#69bfbe"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8335 13.7029H35.4917V27.4771L31.1088 31.8603H24.224L20.4706 35.6135V31.8603H14.8335V13.7029ZM21.7199 26.2265H24.224V18.7143H21.7199V26.2265ZM28.6052 26.2265H31.1087V18.7143H28.6052V26.2265Z",
    fill: "#69bfbe"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitchPeque);
export default __webpack_public_path__ + "static/media/twitch-peque.660f0eb5eefef84b239fa4715efec897.svg";
export { ForwardRef as ReactComponent };